import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addEdgeToDecisionTreePath, returnToPreviousMacroWizardPath } from '../../../../actions/searchActions';
import { getDecisionNodeAtPath } from '../../../../extractFromState';

import { BackButton, NextButton } from '../../../common/buttonsComponents';
import { ActionsButtonsWrapper, Title, TopContainer } from '../../DecisionTree.styles';

import { Container, InnerContainer, TagButton, TagIcon } from './DTAddOrderTagsNode.styles';
import { twoBtnPopupCreator } from '../../../popups/ConfirmPopup/helper';
import { setOrderTags } from '../../../../actions/tools/OrdersSearchActions';

const DTAddOrderTagsNode = () => {
  const dispatch = useDispatch();
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const [selectedTags, setSelectedTags] = useState([]);

  const isNextButtonActive = () => {
    return selectedTags.length > 0;
  };

  const onNextStepConfirm = useCallback(() => {
    dispatch(setOrderTags(selectedTags));
    dispatch(addEdgeToDecisionTreePath('tag_selected'));
  }, [dispatch, selectedTags]);

  const handleNextBtnClick = () => {
    twoBtnPopupCreator({
      content: {
        main: 'Please make sure you selected the correct tag(s) as this will get added to the order',
        iconPath: '/images/green-alert-bell.svg',
      },
      btnConfig: {
        dismiss: 'DISMISS',
        confirm: 'CONFIRM',
      },
      onConfirm: onNextStepConfirm,
    });
  };

  const handleTagSelection = (tag) => {
    setSelectedTags((prevTags) => {
      const tagExists = prevTags.some((prevTag) => prevTag.value === tag.value);

      if (tagExists) {
        return prevTags.filter((prevTag) => prevTag.value !== tag.value);
      }

      return [...prevTags, tag];
    });
  };

  const filterUniqueTags = (tags) => {
    return tags.reduce((uniqueTags, tag) => {
      if (!uniqueTags.some((uniqueTag) => uniqueTag.value === tag.value)) {
        uniqueTags.push(tag);
      }

      return uniqueTags;
    }, []);
  };

  const isTagSelected = (tag) => selectedTags.some((selectedTag) => selectedTag.value === tag.value);

  return (
    <TopContainer>
      <Container>
        {decisionNode.title && <Title>{decisionNode.title}</Title>}
        <InnerContainer>
          {filterUniqueTags(decisionNode.orderTags).map((tag, index) => {
            const tagSelected = isTagSelected(tag);

            return (
              <TagButton key={index} onClick={() => handleTagSelection(tag)} selected={tagSelected}>
                {tagSelected && <TagIcon src="/images/checkmark.svg" alt={'checkmark'} />}
                {tag.label}
              </TagButton>
            );
          })}
        </InnerContainer>
      </Container>
      <ActionsButtonsWrapper>
        <NextButton
          disabled={!isNextButtonActive()}
          active={isNextButtonActive()}
          type="submit"
          onClick={handleNextBtnClick}
        >
          NEXT
        </NextButton>
        <BackButton onClick={() => dispatch(returnToPreviousMacroWizardPath())}>BACK</BackButton>
      </ActionsButtonsWrapper>
    </TopContainer>
  );
};

export default DTAddOrderTagsNode;
